import React, { ChangeEvent, FC, InputHTMLAttributes } from "react"
import styled from "styled-components"
import { theme } from "../../../util/styles/theme"
import { BaseInput, BaseInputStyles, InputProps } from "../base-input/BaseInput"

export interface SelectOption {
  displayName: string
  value: string
}

const Select = styled(BaseInput).attrs({ as: "select", type: "select" })`
  select::-ms-expand {
    // Hide arrow in IE11
    display: none;
  }

  ${BaseInputStyles};
  background: url("/dropdown-arrow.svg") no-repeat
    calc(100% - ${theme.spacings.small}) 50% / 2rem;

  overflow: hidden;
  padding-right: ${theme.spacings.xlarge};
  text-overflow: ellipsis;
  white-space: nowrap;
`

export type SelectInputProps = {
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  options?: SelectOption[]
  showEmptyValueOption?: boolean
  value?: string
} & InputProps &
  Pick<InputHTMLAttributes<HTMLInputElement>, "defaultValue" | "disabled">

export const SelectInput: FC<SelectInputProps> = ({
  options,
  value,
  showEmptyValueOption,
  ...rest
}) => {
  return (
    <Select value={value} {...rest}>
      {options.map(option => {
        const hideOption = !showEmptyValueOption && option.value === ""

        return (
          <option
            key={option.value + option.displayName}
            value={option.value}
            disabled={hideOption}
            hidden={hideOption}
          >
            {option.displayName}
          </option>
        )
      })}
    </Select>
  )
}

SelectInput.defaultProps = {
  showEmptyValueOption: false,
}
